<footer class="app-footer">
  <div class="footer-inner">
    <div class="footer-grid">
      <div class="footer-col">
        <div class="app-footer-list"><strong>CÔNG TY TNHH ALIBABA.COM VIỆT NAM</strong></div>
        <p class="muted">Trụ sở chính:
          Tầng 19, Toà Nhà Saigon Centre, Số 67 Đường Lê Lợi, P .Bến Nghé, Quận 1
        </p>
        <p class="muted">Chi nhánh Bình Dương:
          Lầu 10, Becamex Tower, 230 Đại lộ Bình Dương, Thủ Dầu Một, Bình Dương
        </p>
        <p class="muted">Chi nhánh Đồng Nai:
          Lầu 9, TTC Plaza, Võ Thị Sáu, Phường thống nhất, TP Biên Hoà, Đồng Nai
        </p>
        <p class="muted">Chi nhánh Long An:
          123 Cộng Hòa, Phường 12, Tân Bình, Thành phố Hồ Chí Minh 700000, Việt Nam
        </p>
        <p class="muted">Chi nhánh Hà Nội:
          Tầng 25, Toà số 1 Capital Place Building, Số 29 Liễu Giai, Ngọc Khánh, Ba Đình, Hà Nội
        </p>
      </div>

      <div class="footer-col partners">
        <h4 class="app-footer-title">🤝 Đối tác</h4>
        <div class="partners-list" aria-label="Đối tác">
          <span class="partner-badge" title="Shopee">Shopee</span>
          <span class="partner-badge" title="Lazada">Lazada</span>
          <span class="partner-badge" title="Tiki">Tiki</span>
          <span class="partner-badge" title="Viettel Post">Viettel Post</span>
        </div>

        <h4 class="app-footer-title mt">👥 Thống kê</h4>
        <div class="stats-row" role="list">
          <div class="stat" role="listitem">
            <div class="stat-number">10k+</div>
            <div class="stat-label">Khách hàng</div>
          </div>
          <div class="stat" role="listitem">
            <div class="stat-number">500+</div>
            <div class="stat-label">Đối tác</div>
          </div>
          <div class="stat" role="listitem">
            <div class="stat-number">1M+</div>
            <div class="stat-label">Giao dịch</div>
          </div>
        </div>
      </div>

      <!-- Removed policy/support/security/social sections as requested -->
    </div>

    <div class="footer-bottom">
      <div class="copy">© 2026 ALIBABA.COM VIỆT NAM. All rights reserved.</div>
      
    </div>
  </div>
</footer>
